export default __webpack_public_path__ + "static/media/nantes3.d3275337.jpg";